module.exports = __webpack_public_path__ + "img/logo_manual_makers.b4fcd6d2.png";